import { JSX } from 'react';

// components
import { AtClickable } from '../at-clickable';

// types
import {
  EClickableSize,
  EClickableVariants,
} from '../at-clickable/at-clickable.types';
import { IAtbuttonProps } from './at-button.types';

export const AtButton = ({
  children,
  className,
  iconPosition,
  label,
  outline = false,
  size = EClickableSize.LG,
  variant = EClickableVariants.PRIMARY,
  onClick,
  ariaLabel,
  buttonType,
}: IAtbuttonProps): JSX.Element => {
  return (
    <AtClickable
      className={className}
      iconPosition={iconPosition}
      label={label}
      outline={outline}
      size={size}
      variant={variant}
      onClick={onClick}
      ariaLabel={ariaLabel}
      buttonType={buttonType}
      interactLocation="at-button"
    >
      {children}
    </AtClickable>
  );
};
